/**
 *  @class
 *  @function TabSwitcher
 */
if (!customElements.get('tab-switcher')) {
  class TabSwitcher extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      // [data-group] excludes plain link-tabs (Tabs section's "Link" setting) -
      // those just navigate away and never toggle a panel.
      this.tabs = Array.from(this.querySelectorAll('.tab-switcher--tab[data-group]'));
      this.tabClickHandlers = [];
      this.tabs.forEach((tab) => {
        let handler = () => this.selectGroup(tab);
        this.tabClickHandlers.push({ tab, handler });
        tab.addEventListener('click', handler);
      });

      let activeTab = this.tabs.find((tab) => tab.classList.contains('active')) || this.tabs[0];
      if (activeTab) {
        this.selectGroup(activeTab);
      }
    }
    disconnectedCallback() {
      if (this.tabClickHandlers) {
        this.tabClickHandlers.forEach(({ tab, handler }) => {
          tab.removeEventListener('click', handler);
        });
      }
    }
    selectGroup(activeTab) {
      let group = activeTab.dataset.group;

      this.tabs.forEach((tab) => {
        let isActive = tab === activeTab;
        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      document.querySelectorAll('.tab-group-panel').forEach((panel) => {
        panel.style.display = panel.dataset.tabGroup === group ? '' : 'none';
      });
    }
  }
  customElements.define('tab-switcher', TabSwitcher);
}
